import styled from 'styled-components'
import { FaExchangeAlt, FaChartLine, FaColumns } from 'react-icons/fa'
import { GiCardExchange } from "react-icons/gi"
import Text from '../../core/utils/Text'
import {HOME} from "../../core/constants/urls";

const BottomBar = () => {
	return (
		<Body>
			<BottomBarWrapper>
				{tabs.map((tab, idx) => (
					<a href={tab.href}>
						<TabItem>
							<tab.icon size={18} />
							<DText>
								<Text tid={tab.name} />
							</DText>
						</TabItem>
					</a>
				))}
			</BottomBarWrapper>
		</Body>
	)
}

const DashboardIcon = styled(FaColumns)`
	color: ${(props) => (props.active ? 'rgb(39, 163, 220)' : props.theme.color)};
`
const MarketsIcon = styled(FaChartLine)`
	color: ${(props) => (props.active ? 'rgb(39, 163, 220)' : props.theme.color)};
`
const OtcIcon = styled(FaExchangeAlt)`
	color: ${(props) => (props.active ? 'rgb(39, 163, 220)' : props.theme.color)};
`
const WalletIcon = styled(GiCardExchange)`
	color: ${(props) => (props.active ? 'rgb(39, 163, 220)' : props.theme.color)};
`

const tabs = [
	{ name: 'home-page', icon: DashboardIcon, href: HOME },
	{ name: 'otc-trade', icon: OtcIcon, href: HOME + 'otc2/form' },
	{ name: 'markets', icon: MarketsIcon, href: HOME + 'market' },
	{ name: 'p2p-trade', icon: WalletIcon, href: HOME + 'trade/BTC_IRT' },
]

const Body = styled.div`
	position: fixed;
	bottom: 0;
	width: 100%;
	height: 60px;
	direction: ${(props) => (props.theme.english ? 'ltr' : 'rtl')};
	background-color: ${(props) => props.theme.secondaryBg};
	box-shadow: -2px 0 4px ${(props) => props.theme.mainBg};
	padding: 10px 30px;
	z-index: 1001;
`

const BottomBarWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: ${(props) => (props.active ? props.theme.mainOrange : props.theme.color)};
`

const DText = styled.div`
	font-size: 0.775rem;
	font-weight: 600;
`

const TabItem = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	height: 40px;
`

export default BottomBar
